import { memo } from 'react';
import { CopyString } from 'components';
import { ChangedValue } from './ChangedValue';

import * as S from './ContentItem.styled';

export const ContentItem = memo(({ cm_campaignid, changes }) => {
  return (
    <>
      {changes?.length > 0 ? (
        <S.Update>
          <S.Title>
            <S.CampaignName>{changes[0].cm_name}</S.CampaignName>
            <CopyString label='ID' text={cm_campaignid.toString()} />
          </S.Title>
          {changes &&
            changes.map((c, i) => {
              return (
                <ChangedValue
                  key={i}
                  eventType={c.event_type}
                  oldValue={c.previous_value}
                  newValue={c.new_value}
                  userName={c.user_name}
                />
              );
            })}
        </S.Update>
      ) : (
        <div>No changes</div>
      )}
    </>
  );
});

ContentItem.displayName = 'ContentItem';
